import { useEffect, useState } from "react";
import { useLazySession } from "./useLazySession";

export interface ContactDetails {
  name: string;
  email: string;
  phone: string;
}

const DeviceContactDetailsService = {
  loadContactDetails: (): ContactDetails => {
    try {
      const name = localStorage.getItem("enquiryName") || "";
      const email = localStorage.getItem("enquiryEmail") || "";
      const phone = localStorage.getItem("enquiryPhone") || "";
      return {
        name,
        email,
        phone,
      };
    } catch (ex) {
      console.warn("CLIENT_KNOWN_WARNING: getting from local storage", ex);
    }
    return {
      name: "",
      email: "",
      phone: "",
    };
  },
  saveContactDetails: (details: ContactDetails) => {
    try {
      localStorage.setItem("enquiryName", details.name);
      localStorage.setItem("enquiryEmail", details.email);
      localStorage.setItem("enquiryPhone", details.phone);
    } catch (ex) {
      console.warn("CLIENT_KNOWN_WARNING: setting to local storage", ex);
    }
  },
};

export function useContactDetails() {
  const [contactDetails, setContactDetails] = useState<
    ContactDetails | undefined
  >();
  const { session, isLoaded } = useLazySession();

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    const deviceDetails = DeviceContactDetailsService.loadContactDetails();
    const details = {
      name: deviceDetails.name || session?.user?.name || "",
      email: deviceDetails.email || session?.user?.email || "",
      phone: deviceDetails.phone,
    };
    setContactDetails(details);
  }, [session, isLoaded]);

  return {
    contactDetails,
    saveContactDetails: DeviceContactDetailsService.saveContactDetails,
  };
}
